module.exports = __webpack_public_path__ + "media/images/plans/icon-feature-photodate-167e94114d7b83ef0ef4f84c069473dc.png";